import { render, staticRenderFns } from "./SettingsCertificateCard.vue?vue&type=template&id=c70e130c"
import script from "./SettingsCertificateCard.vue?vue&type=script&lang=js"
export * from "./SettingsCertificateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports